<h3 mat-dialog-title>{{title}}</h3>
<div class="mat-dialog-content">
  <div [innerHTML]="message"></div>
</div>
<div mat-dialog-actions class="pull-right">
  <button class="btn btn-default" tabindex="-1" (click)="onCancel()">{{cancelText}}</button>
  &nbsp; &nbsp;
  <button class="btn btn-{{confirmColor}}" tabindex="1" (click)="onConfirm()">{{confirmText}}</button>
</div>
